export default __webpack_public_path__ + "static/media/integrationsDark.54a9dc08.svg";